import { postApacheUserToken } from "@/services/Login";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { useEffect, useRef } from "react";
import { useMutation } from "@tanstack/react-query";
import { getRuntimeConfig } from "@/utils/runtimeConfig";

const DASHBOARD_ID = getRuntimeConfig("APACHE_TRACKING_DASHBOARDID");
const SUPERSET_URL = getRuntimeConfig("APACHE_URL");

interface TrackingChartProps {
  companySpecificProductId: number;
  currentCompanyId: number | undefined;
}

export default function Reports({ companySpecificProductId, currentCompanyId }: TrackingChartProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const { mutateAsync: getApacheUserToken } = useMutation({
    mutationFn: (uuid: string) => postApacheUserToken(uuid, "no"),
  });

  useEffect(() => {
    async function loadDashboard() {
      if (!containerRef.current) return;
      await embedDashboard({
        id: DASHBOARD_ID,
        supersetDomain: SUPERSET_URL,
        mountPoint: containerRef.current,
        fetchGuestToken: async () => await getApacheUserToken(DASHBOARD_ID).then((res) => res.data.token),
        dashboardUiConfig: {
          filters: { visible: true },
          hideTitle: true,
          hideChartControls: true,
          urlParams: {
            companyId: currentCompanyId,
            companySpecificProductId: companySpecificProductId,
          },
        },
      });

      const iframe = containerRef.current.querySelector("iframe");
      if (iframe) {
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.border = "none";
        iframe.style.display = "block";
      }
    }

    loadDashboard().then();
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "100vh",
        margin: "0 auto",
        border: "none",
        overflow: "hidden",
      }}
    />
  );
}
